"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SSNInput = function SSNInput(_ref) {
  var defaultValue = _ref.defaultValue,
      guide = _ref.guide,
      inputRef = _ref.inputRef,
      isMasked = _ref.isMasked,
      mask = _ref.mask,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      reference = _ref.forwardRef,
      restOfProps = _objectWithoutProperties(_ref, ["defaultValue", "guide", "inputRef", "isMasked", "mask", "maxLength", "onChange", "forwardRef"]);

  var initialState = {
    rawValue: '',
    formattedValue: '',
    maskedValue: ''
  };
  var defaultInitialState = (0, _utils.handleDefaultValues)(defaultValue);

  var _useState = (0, _react.useState)(defaultValue ? defaultInitialState : initialState),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var formattedValue = values.formattedValue,
      maskedValue = values.maskedValue;

  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;

    var _handleValues = (0, _utils.handleValues)(_objectSpread({}, values, {
      isMasked: isMasked
    }), value),
        rawComputedValue = _handleValues.rawValue,
        formattedComputedValue = _handleValues.formattedValue,
        maskedComputedValue = _handleValues.maskedValue;
    /**
     * Expose `rawValue` and `formattedValue` on the event object
     */


    e.target.rawValue = rawComputedValue;
    e.target.formattedValue = formattedComputedValue;

    if (typeof onChange === 'function') {
      onChange(e);
    }

    setValues({
      rawValue: rawComputedValue,
      // In order for formatted values to be deleted properly, the most recent value is used as formattedValue
      formattedValue: isMasked ? formattedComputedValue : value,
      maskedValue: maskedComputedValue
    });
  };

  var inputValue = isMasked ? maskedValue : formattedValue;
  return _react.default.createElement(_reactTextMask.default, _extends({}, restOfProps, {
    render: function render(ref, props) {
      /**
       * Extract out `defaultValue` from being passed to the input element, as we cannot use both `value` and `defaultValue` for controlled inputs
       * Prevents a bug that shows unmasked values in a masked state after adding characters in between the input string
       */
      var defaultVal = props.defaultValue,
          rest = _objectWithoutProperties(props, ["defaultValue"]);

      return _react.default.createElement("input", _extends({}, rest, {
        ref: ref
      }));
    },
    ref: function ref(_ref2) {
      /**
       * Pass the input reference to the parent
       * Need to create an object with a "current" property to match the API for non-custom inputs
       */
      if (typeof inputRef === 'function' && _ref2) {
        inputRef({
          current: _ref2.inputElement
        });
      }
    },
    guide: guide,
    maxLength: maxLength,
    mask: mask,
    onChange: handleInputChange,
    value: inputValue
  }));
};

SSNInput.propTypes = {
  defaultValue: _propTypes.string,
  forwardRef: (0, _propTypes.shape)({
    current: _propTypes.object
  }),
  guide: _propTypes.bool,
  isMasked: _propTypes.bool,
  inputRef: _propTypes.func,
  mask: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([(0, _propTypes.instanceOf)(RegExp), _propTypes.string])),
  onChange: _propTypes.func,
  maxLength: _propTypes.number
};
SSNInput.defaultProps = {
  defaultValue: null,
  forwardRef: {},
  guide: false,
  isMasked: true,
  inputRef: null,
  // prettier-ignore
  mask: [/[0-9\u2022/]/, /[0-9\u2022/]/, /[0-9\u2022/]/, ' ', '-', ' ', /[0-9\u2022/]/, /[0-9\u2022/]/, ' ', '-', ' ', /[0-9\u2022/]/, /[0-9\u2022/]/, /[0-9\u2022/]/, /[0-9\u2022/]/],
  // formatted ssn value
  maxLength: 15,
  onChange: null
};
/**
 * Refs are not handled properly without this function
 */

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(SSNInput, _extends({}, props, {
    forwardRef: ref
  }));
});

exports.default = _default;
